module.exports = __webpack_public_path__ + "img/joule-logo.431198cc.png";